import dayjs from 'dayjs';
// The hour-registration page always shows dates in English, independent of
// the global moment/i18n locale (which can render Dutch month abbreviations).
const en = (date) => dayjs(date).locale('en');
export const formatDisplayDate = (date) => {
    if (date === null || date === undefined || date === '')
        return '';
    const parsed = en(date);
    return parsed.isValid() ? parsed.format('D MMM YYYY') : '';
};
// Compact English range: "1–4 Oct", "29 Sep – 5 Oct", "29 Dec 2026 – 4 Jan 2027".
export const formatShortRange = (from, to) => {
    if (!from)
        return '';
    const start = en(from);
    if (!start.isValid())
        return '';
    const end = to ? en(to) : start;
    if (!end.isValid() || start.isSame(end, 'day'))
        return start.format('D MMM');
    if (start.year() !== end.year())
        return `${start.format('D MMM YYYY')} – ${end.format('D MMM YYYY')}`;
    if (start.month() !== end.month())
        return `${start.format('D MMM')} – ${end.format('D MMM')}`;
    return `${start.format('D')}–${end.format('D MMM')}`;
};
export const formatMonthYear = (month, year) => en(`${year}-${String(month).padStart(2, '0')}-01`).format('MMMM YYYY');
